import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Image } from "expo-image";
import { SystemBars } from "react-native-edge-to-edge";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import LoginFlower from "../assets/Login_flower.svg";
import LoginPlant from "../assets/Login_plant.svg";
import { useAppContext } from "./AppContext";
import { ScrollView } from "./ScrollView";
import { Heading } from "./Text";
import { View } from "./View";
import { manifest } from "../constants";
import { useWindowDimensions } from "../hooks/useWindowDimensions";
import { useI18n } from "../lib/i18n";
import { useTheme } from "../styles";
/**
 * Renders a common layout for authentication and other logged out screens.
 *
 * ```typescript
 * {
 *   testID?: string;
 *   heading: string | null;
 *   children: ReactNode;
 *   _scrollView?: ComponentType<ScrollViewProps>;
 *   graphic?: ReactNode;
 *   logo?: ReactNode;
 * }
 * ```
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-27}
 */ export function AuthScreenContainer(props) {
    var height = useWindowDimensions().height;
    var scheme = useTheme().scheme;
    var _props__scrollView;
    var ScrollViewComponent = (_props__scrollView = props._scrollView) !== null && _props__scrollView !== void 0 ? _props__scrollView : ScrollView;
    var _useAppContext = useAppContext(), Logo = _useAppContext.Logo, onboardingGraphic = _useAppContext.onboardingGraphic;
    var $t = useI18n().$t;
    var insets = useSafeAreaInsets();
    var _props_graphic, _ref;
    return /*#__PURE__*/ _jsxs(View, {
        flex: 1,
        style: {
            backgroundColor: 'white'
        },
        children: [
            /*#__PURE__*/ _jsx(SystemBars, {
                style: scheme === 'dark' ? 'light' : 'dark'
            }),
            /*#__PURE__*/ _jsxs(ScrollViewComponent, {
                style: {
                    zIndex: 1
                },
                contentContainerStyle: {
                    paddingTop: insets.top + height / 12,
                    flexGrow: 1,
                    paddingBottom: insets.bottom + 100
                },
                testID: "".concat(props.testID, "_scrollView"),
                children: [
                    props.logo ? props.logo : Logo ? /*#__PURE__*/ _jsx(View, {
                        style: {
                            alignItems: 'center'
                        },
                        children: /*#__PURE__*/ _jsx(Image, {
                            source: Logo,
                            style: {
                                height: height / 8,
                                width: '70%'
                            },
                            contentFit: "contain",
                            contentPosition: "center",
                            "aria-label": $t({
                                id: 'AuthScreenContainer_logoLabel',
                                defaultMessage: '{appName} Logo'
                            }, {
                                appName: manifest.name
                            })
                        })
                    }) : null,
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            paddingHorizontal: 20,
                            flex: 1,
                            marginTop: 20
                        },
                        testID: props.testID,
                        children: [
                            props.heading ? /*#__PURE__*/ _jsx(Heading, {
                                text: props.heading,
                                level: 1,
                                textAlign: "center",
                                style: {
                                    marginTop: 20,
                                    marginBottom: 10
                                }
                            }) : null,
                            props.children
                        ]
                    })
                ]
            }),
            (_ref = (_props_graphic = props.graphic) !== null && _props_graphic !== void 0 ? _props_graphic : onboardingGraphic) !== null && _ref !== void 0 ? _ref : /*#__PURE__*/ _jsxs(View, {
                style: {
                    position: 'absolute',
                    right: 0,
                    left: 0,
                    bottom: 0,
                    flexDirection: 'row',
                    alignSelf: 'stretch',
                    alignItems: 'flex-end',
                    justifyContent: 'space-between',
                    paddingRight: 40
                },
                children: [
                    /*#__PURE__*/ _jsx(Image, {
                        source: LoginPlant,
                        style: {
                            height: height / 6,
                            aspectRatio: 122 / 146
                        }
                    }),
                    /*#__PURE__*/ _jsx(Image, {
                        source: LoginFlower,
                        style: {
                            height: height / 6,
                            aspectRatio: 36 / 130
                        }
                    })
                ]
            })
        ]
    });
}
